import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { ConsolidatedTransactions } from '../../domain/Transaction/entities/ConsolidatedTransaction/ConsolidatedTransactionResponseDTO';
import { Account } from '../../../../account/src/domain/Account/entities';

export interface ConsolidatedTransactionsProviderProps {}

export type ConsolidatedTransactionListFilters = {
  beneficiaryName: string;
  fromAmount: string; // amount field
  toAmount: string;
  fromTrxDate: string;
  toTrxDate: string;
  pageSize: number;
  pageOffset: number;
  customerId: string;
  orderBeneficiaryAccount?: string;
  orderStatus?: number; // status field
  orderStatusDescription?: string; // description of status
  valueDateFrom?: string;
  valueDateTo?: string;
  account?: Nullable<Account>;
  orderDirection?: number;
};

export type ConsolidatedTransactionsProviderState = {
  consolidatedTransactionListData?: Nullable<ConsolidatedTransactions>;
  consolidatedTransactionListFilters: Partial<ConsolidatedTransactionListFilters & { timestamp?: string }>;
  resetConsolidatedTransactionsListFilters: () => void;
  onConsolidatedTransactionListFiltersChange: (
    filters: Partial<ConsolidatedTransactionListFilters>,
    nextPage?: number,
    totalPages?: number,
  ) => void;
  refetchConsolidatedTransactionList: Function;
  loadingState: {
    isLoadingConsolidatedTransactionList: boolean;
  };
  errorState: {
    consolidatedTransactionListError?: AxiosError<APIGatewayResponse<ConsolidatedTransactions>, any>;
  };
  lastPaginationPageVisited: number;
  onSetLastPaginationPageVisited: (value: number) => void;
};

export enum ConsolidatedTransactionsActionTypes {
  setConsolidatedTransactionListFilters = '@@/Transactions/setConsolidatedTransactionListFilters',
  setLastPaginationPageVisited = '@@/Transactions/setLastPaginationPageVisited',
}
